// Tap IN Radio brand asset (user-provided, 2026-02-22).
// Used as the slipmat on DJ platters AND the masthead logo on all
// listener-facing + host-facing Radio pages.
export const TAPIN_RADIO_LOGO =
  "https://customer-assets.emergentagent.com/job_live-broadcast-53/artifacts/k7ct3b5t_cf170c2a-df6a-4068-b200-019abcc0b011.png";
